const ImageArrowInCircle = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34">
			<path
				fillRule="evenodd"
				d="M17 32.584c8.744 0 15.833-7.09 15.833-15.834S25.744.917 17 .917C8.255.917 1.167 8.006 1.167 16.75c0 8.745 7.088 15.834 15.833 15.834Zm0 .833c9.205 0 16.667-7.462 16.667-16.667C33.667 7.545 26.205.083 17 .083 7.795.083.333 7.545.333 16.75c0 9.205 7.462 16.667 16.667 16.667Z"
				clipRule="evenodd"
			/>
			<path d="m20.333 12.925-1.268-1.175-5.398 5 5.398 5 1.268-1.175-4.12-3.825 4.12-3.825Z" />
		</svg>
	);
};

export default ImageArrowInCircle;
